import React from 'react';
import { Segment, Icon, Button, Grid, Header } from 'semantic-ui-react';

const CategoryGrid = ({ categories, onItemClick }) => {
  return (
    <Segment raised padded>
      <Grid stackable columns={3} divided>
        {categories.map((category, index) => (
          <Grid.Column key={index}>
            <Segment raised>
              <Header as="h3" icon style={{ color: '#a9885c' }}>
                <Icon name={category.icon} className="custom-icon-body" />
                {category.title}
              </Header>
              <p>{category.description}</p>
              <Button
                fluid
                className="custom-button-body"
                onClick={() => onItemClick(category)}
              >
                Explore {category.title}
              </Button>
            </Segment>
          </Grid.Column>
        ))}
      </Grid>
    </Segment>
  );
};

export default CategoryGrid;